import template from 'text!./templates/default.html';

export default [function () {
    return {
        restrict: 'E',
        scope: { item: '&' },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-form/Default.js
// module id = 280
// module chunks = 0